import "./chatbot.css";

const CHATBOT_ICON_SRC = `${process.env.PUBLIC_URL || ""}/chatbot/chatbot-bot-icon.png`;

export default function ChatbotLauncher({ isOpen, onClick, disabled }) {
  if (isOpen) {
    return null;
  }

  return (
    <button
      type="button"
      className="chatbot-launcher"
      onClick={onClick}
      disabled={disabled}
      aria-label="Open AptaBot"
      title="Open AptaBot"
    >
      <img className="chatbot-launcher__icon" src={CHATBOT_ICON_SRC} alt="" aria-hidden="true" />
    </button>
  );
}
